// src/ApiService/staffAbsencesApi.js
// IMPORTANT:
// - Do NOT prefix with "/api" here unless you are 100% sure baseURL does NOT already include it.
// - This style matches your existing wrappers: "HMCareTask/..." (relative path).
// - Also: axios interceptors that add Authorization typically work reliably with relative paths.

export const staffAbsencesApi = (api) => ({
  // list absences for a staff member
  getByAgent: (agentId) => api.get(`StaffAbsences/agent/${agentId}`),

  // get one
  getById: (id) => api.get(`StaffAbsences/${id}`),

  // create
  createOffSick: (agentId, payload) => api.post(`StaffAbsences/${agentId}/offsick`, payload),
  createHoliday: (agentId, payload) => api.post(`StaffAbsences/${agentId}/holiday`, payload),

  // workflow
  approve: (id) => api.post(`StaffAbsences/${id}/approve`, {}),
  cancel: (id) => api.post(`StaffAbsences/${id}/cancel`, {}),

  // calendar range (recommended endpoint)
getRange: ({ from, to, type = "all", status = "all", agentId, search }) =>
  api.get("StaffAbsences/dash", { from, to, type, status, agentId, search }),

});
